export default __webpack_public_path__ + "static/media/active1.47a290ae.svg";